import { createSlice } from '@reduxjs/toolkit';
import { payorsApi } from '@store/rtk/payors';

interface PayonerInfoState {
  id: number;
  website: string;
  companyName: string;
  taxNumber: string;
  primaryNumber: string;
  secondaryNumber: string;
  primaryExt: string;
  secondaryExt: string;
  faxNumber: string;
  email: string;
  linkingNumber: string;
  locationId: string;
  mailingId: string;
  logo_document_id: string;
  companyType: string;
  modeOfTransport: string[];
  physicalAddress: {
    id: number;
    latitude: number;
    longitude: number;
    verified: false;
    stateId: number;
    countyId: number;
    cityId: number;
    zipId: number;
    address1: string;
    address2: string;
    typeId: number;
  };
  mailingAddress: {
    id: number;
    latitude: number;
    longitude: number;
    verified: false;
    stateId: number;
    countyId: number;
    cityId: number;
    zipId: number;
    address1: string;
    address2: string;
    typeId: number;
  };
}

const initialState: {
  info: PayonerInfoState | null;
  payorTypes: any;
  isPayorSaved: boolean;
  payerBasicAnalyticsData: any;
  draftFormValues: any | null;
  draftPayorId: string | number | null;
  isDraftEditing: boolean;
} = {
  info: null,
  payorTypes: null,
  isPayorSaved: true,
  payerBasicAnalyticsData: null,
  draftFormValues: null,
  draftPayorId: null,
  isDraftEditing: false,
};

export const payorsInfoSlice = createSlice({
  name: 'payorsInfo',
  initialState,
  reducers: {
    setIsPayorSaved: (state, { payload }) => {
      state.isPayorSaved = payload;
    },
    setPayorDraft: (state, { payload }) => {
      state.draftFormValues = payload.values;
      state.draftPayorId = payload.payorId;
      state.isDraftEditing = payload.isEditing;
    },
    clearPayorDraft: (state) => {
      state.draftFormValues = null;
      state.draftPayorId = null;
      state.isDraftEditing = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        payorsApi.endpoints.getPayors.matchFulfilled,
        (state, { payload }) => {
          state.info = payload;
        }
      )
      .addMatcher(
        payorsApi.endpoints.getPayorTypes.matchFulfilled,
        (state, { payload }) => {
          state.payorTypes = payload;
        }
      )
      .addMatcher(
        payorsApi.endpoints.payerBasicAnalytics.matchFulfilled,
        (state, { payload }) => {
          state.payerBasicAnalyticsData = payload;
        }
      );
  },
});

export const selectPayorsInfo = (state) => state.payorsInfo;
export const modeOfTransportTypes = (state) =>
  state.payorsInfo.modeOfTransportTypes;

export const { setIsPayorSaved, setPayorDraft, clearPayorDraft } =
  payorsInfoSlice.actions;
export const payorsInfoReducer = payorsInfoSlice.reducer;
